import { render } from "./Atencion_Interconsulta.vue?vue&type=template&id=7d96e886&scoped=true"
import script from "./Atencion_Interconsulta.vue?vue&type=script&lang=js"
export * from "./Atencion_Interconsulta.vue?vue&type=script&lang=js"

import "./Atencion_Interconsulta.vue?vue&type=style&index=0&id=7d96e886&scoped=true&lang=css"
import "@/assets/css/microfono.css?vue&type=style&index=1&id=7d96e886&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=2&id=7d96e886&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d96e886"]])

export default __exports__